var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4402 2.66602H17.3385C16.7792 2.66602 16.3216 3.09639 16.3216 3.62239V18.3028H21.4572V3.62239C21.4572 3.09639 20.9995 2.66602 20.4402 2.66602ZM13.5758 11.9907H10.4741C9.91481 11.9907 9.45718 12.4211 9.45718 12.9471V18.3028H14.5928V12.9471C14.5928 12.4211 14.1351 11.9907 13.5758 11.9907ZM6.71142 7.44791H3.60972C3.0504 7.44791 2.59277 7.87828 2.59277 8.40429V18.3028H7.72837V8.40429C7.72837 7.87828 7.27074 7.44791 6.71142 7.44791Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2373 20.9346H0.762712C0.355932 20.9346 0 20.5998 0 20.2173C0 19.8347 0.355932 19.5 0.762712 19.5H23.2373C23.6441 19.5 24 19.8347 24 20.2173C24 20.5998 23.6949 20.9346 23.2373 20.9346Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.cdecf2bd1af1a8a50ad9ae29c9b02d07.svg";
export { ForwardRef as ReactComponent };